/*
 * Copyright (C) Motorola Solutions, INC.
 * All Rights Reserved.
 */

import { ControlMessage } from './abstract-control-message';

enum STATE {
    JACK_BOX_DENIED = 0x00,
    JACK_BOX_PERMITTED = 0x01
}

export class IrrPlaybackPermissionsMessage extends ControlMessage {
  public static readonly STATE = STATE;

  constructor(arrayBuffer?: ArrayBufferLike) {
    super(arrayBuffer);
    this.id = ControlMessage.ControlMessageIdentifier.IRR_PLAYBACK_PERMISSIONS;
  }

  public withState(activity: STATE) {
    this.payload1 = activity;
    return this;
  }

  override payload1String(): string {
    return STATE[this.payload1];
  }
}
